import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { GlobalConfigPayload, GlobalConfigResponse } from '../../models/fund/global-config.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalConfigApiService {
  private readonly resourceUrl = '/configuration/frontend/global';

  constructor(private apiService: ApiService) {}

  getConfiguration(): Observable<GlobalConfigResponse> {
    return this.apiService.get(this.resourceUrl) as Observable<GlobalConfigResponse>;
  }

  updateConfiguration(payload: GlobalConfigPayload): Observable<any> {
    return this.apiService.put(this.resourceUrl, payload);
  }
}
